<div class="header">
  <a class="brand" routerLink="/">
    <img src="assets/logo.png" alt="" />
  </a>
  <div class="menu">
    <a
      routerLink="/"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active"
      >Home</a
    >
    <a routerLink="/recipes" routerLinkActive="active">Recipes</a>
    <a routerLink="/profile" routerLinkActive="active">My Recipes</a>
    <button class="mainBtn" (click)="login()">Login</button>
    <!-- <div class="dropdown" dropdown>
      <div class="profilePreview">
        <div class="userIcon">
          <div class="cover">
            <img src="assets/user.jpg" alt="" />
            <div class="empty">T</div>
          </div>
        </div>
        <ion-icon name="chevron-down-outline"></ion-icon>
      </div>
      <div class="dropmenu">
        <button>My profile</button>
        <button>Logout</button>
      </div>
    </div> -->
  </div>
</div>
